import { LATE_COMING_REQUEST } from "../actions/utilities";
const INITIAL_STATE = {
    getLateComingLoading: false,
    getLateComingSuccess: false,
    getLateComingFailure: false,
    getLateComingError: null,
    lateComingList: []
}

export const lateComingReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LATE_COMING_REQUEST.GET_LIST_REQUEST:
            return {
                ...state,
                getLateComingLoading: true,
                getLateComingSuccess: false,
                getLateComingFailure: false,
                getLateComingError: null
            }
        case LATE_COMING_REQUEST.GET_LIST_SUCCESS:
            return {
                ...state,
                getLateComingLoading: false,
                getLateComingSuccess: true,
                getLateComingFailure: false,
                getLateComingError: null,
                lateComingList: action.payload
            }
        case LATE_COMING_REQUEST.GET_LIST_FAILURE:
            return {
                ...state,
                getLateComingLoading: false,
                getLateComingSuccess: false,
                getLateComingFailure: true,
                getLateComingError: action.payload
            }
        default:
            return state;
    }
}